import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'
import moment from 'moment'

export interface IState {
  auditList?: any
  auditStats?: any
  entityAuditHistory?: any
  reloadAuditList?: string | null
}

const initialState: IState = {
  auditList: [],
  auditStats: {},
  entityAuditHistory: [],
  reloadAuditList: null,
}

export const auditDucks = createSlice({
  name: 'audit',
  initialState,
  reducers: {
    getListAudit: (state: RootState, action: PayloadAction<any>) => {
      state.auditList = { loading: true, queryStr: action.payload }
    },
    getListAuditSuccess: (state, action: PayloadAction<any>) => {
      state.auditList = { loading: false, ...action.payload }
    },
    getListAuditFail: (state, action: PayloadAction<any>) => {
      state.auditList = { loading: false, ...action.payload }
    },

    getAuditStats: (state: RootState, action: PayloadAction<any>) => {
      state.auditStats = { loading: true, queryStr: action.payload }
    },
    getAuditStatsSuccess: (state, action: PayloadAction<any>) => {
      state.auditStats = { loading: false, ...action.payload }
    },
    getAuditStatsFail: (state, action: PayloadAction<any>) => {
      state.auditStats = { loading: false, ...action.payload }
    },

    getAuditByEntity: (state: RootState, action: PayloadAction<any>) => {
      state.entityAuditHistory = { loading: true, params: action.payload }
    },
    getAuditByEntitySuccess: (state, action: PayloadAction<any>) => {
      state.entityAuditHistory = { loading: false, ...action.payload }
    },
    getAuditByEntityFail: (state, action: PayloadAction<any>) => {
      state.entityAuditHistory = { loading: false, ...action.payload }
    },

    setReloadAuditList: (state: RootState) => {
      state.reloadAuditList = String(moment())
    },
  },
})

export const {
  getListAudit,
  getListAuditSuccess,
  getListAuditFail,

  getAuditStats,
  getAuditStatsSuccess,
  getAuditStatsFail,

  getAuditByEntity,
  getAuditByEntitySuccess,
  getAuditByEntityFail,

  setReloadAuditList,
} = auditDucks.actions

export default auditDucks.reducer

